import React, {useEffect} from 'react';
import {useToasts} from 'react-toast-notifications';

const Toast = ({message, type}) => {
    const { addToast } = useToasts();
    useEffect(() => {
        addToast(message, {appearance: type, autoDismiss: true})
    }, []);
    return (
        <div>
        </div>    
    );
}

export default Toast;